import React, { Component } from "react";

const fontStyle = document.createElement("style");
fontStyle.innerHTML = `@import url('https://fonts.googleapis.com/css2?family=Allerta+Stencil&display=swap');`;
document.head.appendChild(fontStyle);

export class AppLogoText extends Component {
  render() {
    const { textStyle = {}, neglectFont = false } = this.props;

    const styles = {
      appLogoText: {
        fontSize: 15,
        lineHeight: "38px",
        fontWeight: "500",
        fontStyle: "normal",
        color: "#0B7E36",
        fontFamily: neglectFont ? "inherit" : '"Allerta Stencil", sans-serif',
        ...textStyle,
      },
    };

    return (
        <span style={styles.appLogoText}>SOLO</span>
     
    );
  }
}
